// app/about/page.js

'use client';

import Header from '../_layouts/header';
import '@STYLE/header.scss';

import '@STYLE/styles/common.css';
import '@STYLE/styles/main.css';
import '@STYLE/styles/all.css';
import '@STYLE/styles/033.css';
import '@STYLE/styles/animate.css';
import '@STYLE/styles/aos.css';
import '@STYLE/styles/board.css';
import '@STYLE/styles/demo.css';
import '@STYLE/styles/color.css';
import '@STYLE/styles/iconmind.css';
import '@STYLE/styles/magnific-popup.css';
import '@STYLE/styles/member.css';
import '@STYLE/styles/navbar.css';
import '@STYLE/styles/bootstrap.min.css';
// import '@STYLE/styles/owl.carousel.min.css';
// import '@STYLE/styles/owl.theme.default.css';
import '@STYLE/styles/prism.css';
import '@STYLE/styles/shop.css';
import '@STYLE/styles/style.css';
import '@STYLE/styles/themify-icons.css';
import '@STYLE/styles/work.css';

import Image from 'next/image';
import Script from 'next/script';
import Link from 'next/link';
import {useEffect} from "react";

export default function AboutPage() {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (window.scrollY > 50) {
        // 스크롤이 50px 이상일 때
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    // 컴포넌트가 언마운트될 때 이벤트 리스너를 제거합니다
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main id='main-wrapper' className='mWrapper'>
      <div id='header' />
      <div id='page-wrapper' className='pWrapper'>
        <header className='imgBg height-title sub-overlay imgBg-bottom'>
          <div className='imgBg-holder col-12'>
            <Image
              src='/images/smartcare.png'
              alt='smartCare'
              fill // 이미지를 부모 요소의 크기에 맞춤 // 이미지를 컨테이너에 맞게 조절
              className='pageImg'
            />
          </div>
          <div
            className='container'
            style={{
              position: 'absolute',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            <div className='row d-flex justify-content-center align-items-center height-title'>
              <div
                className='col-md-12 text-center text-beige'
                data-aos='fade-down'
                data-aos-duration='1400'
              >
                <h2 className='sub-title display-5 font-eng fw-600'>
                  WISE PLAN
                </h2>
              </div>
            </div>
          </div>
          <section className='sub-navbar-wrap'>
            <div className='container'>
              <div className='row no-gutters'>
                <div className='col-12'>
                  <ul className='nav nav-pills nav-fill sub-navbar'>
                    <li className='nav-item'>
                      <Link href='/page1' passHref className='nav-link'>
                        SMARTPAY AI
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <Link href='/page2' passHref className='nav-link'>
                        SMARTPAY BIZ
                      </Link>
                    </li>
                    <li className='nav-item'>
                      <Link href='/page3' passHref className='nav-link'>
                        WISEPLAN
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </header>
        <section className='spacer bg-light'>
          <div className='container'>
            <div className='row d-flex justify-content-center'>
              <div className='col-md-8'>
                <h3
                  className='fw-300 lh-10 font-eng h1 text-center'
                  data-aos='fade-down'
                  data-aos-duration='1200'
                >
                  <strong className='intText'>
                    확고한 사업성을 바탕으로 미래를 준비하는
                  </strong>
                  <br />
                  <span className='intColorSpan smallMarginTop'>
                    아이원페이 주식회사
                  </span>
                </h3>
                <hr className='separator-break' />
                <p
                  className='text-center mb-0'
                  data-aos='fade-down'
                  data-aos-delay='300'
                  data-aos-duration='1200'
                >
                  <span className='intSpanLight'>
                    아이원 페이 주식회사는 확고한 사업성을 바탕으로 미래를
                    준비합니다. 혁신적인 결제 솔루션과 철저한 보안 시스템을 통해
                    안정적이고 효율적인 결제 환경을 제공하며, 지속적인 기술
                    개발과 시장 분석을 통해 변화를 선도합니다. 아이원 페이와
                    함께 신뢰할 수 있는 미래를 설계하세요
                  </span>
                </p>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </section>
        <section
          className='spacer bg-gray'
          style={{ paddingTop: '30px', paddingBottom: '30px' }}
        >
          <div className='container'>
            {/* 첫 번째 아이템 */}
            <div className='row no-gutters bg-white mb-5'>
              <div className='col-lg-6'>
                <div className='hero-wrap img-bg-center height-p'>
                  <Image src='/images/wiseplan01.jpg' alt='wiseplan01' fill />
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='inner-lg'>
                  <div className='box-icon box-icon-side'>
                    <span>
                      <i className='icon-Map2' />
                    </span>
                    <div className='box-icon-title'>
                      <h6 className='mb-2 text-eng text-uppercase fw-600 h5'>
                        <span className='intTextBold'>쉬운 가맹점 찾기</span>
                      </h6>
                      <p className='mb-0'>
                        전국의 가맹점을 손쉽게 찾을수 있습니다
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 두 번째 아이템 */}
            <div className='row no-gutters bg-white mb-5'>
              <div className='col-lg-6'>
                <div className='hero-wrap img-bg-center height-p'>
                  <Image src='/images/wiseplan02.jpg' alt='wiseplan02' fill />
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='inner-lg'>
                  <div className='box-icon box-icon-side'>
                    <span>
                      <i className='icon-Panorama' />
                    </span>
                    <div className='box-icon-title'>
                      <h6 className='mb-2 text-eng text-uppercase fw-600 h5'>
                        <span className='intTextBold'>SMS결제 서비스</span>
                      </h6>
                      <p className='mb-0'>
                        구매자는 결제 URL 내에서 카드정보를 직접 입력하여 쉽고
                        간편하게 결제를 진행할 수 있습니다. 쉽고 간단한 원격문자
                        (SMS) 결제 처리
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 세 번째 아이템 */}
            <div className='row no-gutters bg-white mb-5'>
              <div className='col-lg-6'>
                <div className='hero-wrap img-bg-center height-p'>
                  <Image src='/images/wiseplan03.jpg' alt='wiseplan03' fill />
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='inner-lg'>
                  <div className='box-icon box-icon-side'>
                    <span>
                      <i className='icon-Approved-Window' />
                    </span>
                    <div className='box-icon-title'>
                      <h6 className='mb-2 text-eng text-uppercase fw-600 h5'>
                        <span className='intTextBold'>아이원 멤버쉽</span>
                      </h6>
                      <p className='mb-0'>
                        아이원멤버쉽 포인트로 고객에게 더 많은 혜택을 제공합니다
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 네 번째 아이템 */}
            <div className='row no-gutters bg-white mb-5'>
              <div className='col-lg-6'>
                <div className='hero-wrap img-bg-center height-p'>
                  <Image src='/images/wiseplan04.jpg' alt='wiseplan04' fill />
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='inner-lg'>
                  <div className='box-icon box-icon-side'>
                    <span>
                      <i className='icon-Credit-Card3' />
                    </span>
                    <div className='box-icon-title'>
                      <h6 className='mb-2 text-eng text-uppercase fw-600 h5'>
                        <span className='intTextBold'>
                          I-ONE & SAMSUNG CARD EVENT
                        </span>
                      </h6>
                      <p className='mb-0'>
                        콜라보 이벤트에 구독하고 이벤트에 참여해보세요!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className='section6_text'>
          {' '}
          <strong className='intBoldWhite'>
            가맹점 가입 / 단말기등록 문의
          </strong>
          <br />
          <Link href='/contactUs'>
            <button type='button' className='section6_btn'>
              문의하기
            </button>
          </Link>
        </div>{' '}
      </div>
      {/* <Script id='custom-script' src='/js/jquery.min.js' /> */}
      {/* <Script src='/js/jquery.magnific-popup.min.js' />
      <Script src='/js/jquery.waypoints.min.js' />
      <Script src='/js/jquery.counterup-custom.min.js' />
      <Script src='/js/jquery.touchSwipe.min.js' /> */}
      <Script src='/js/popper.min.js' />
      <Script src='/js/bootstrap.min.js' />
      <Script src='/js/aos.js' />
      <Script src='/js/prism.js' />
      <Script src='/js/custom.min.js' />
      {/* <Script src='/js/demo.js' /> */}
      {/* 
      <Script src='/js/bootstrap-touch-slider/bootstrap-touch-slider.js' />
      <Script src='/js/isotope.pkgd.min.js' /> */}
      {/* <Script src='/js/imagesloaded.pkgd.min.js' /> */}
    </main>
  );
}
